import React, { createContext, useCallback, useContext, useState } from 'react';

const UnsavedChangesContext = createContext({
  hasUnsavedChanges: false,
  registerUnsavedChanges: () => {},
});

export const UnsavedChangesProvider = ({ children }) => {
  const [dirtyForms, setDirtyForms] = useState(() => new Set());
  const registerUnsavedChanges = useCallback((id, dirty) => {
    setDirtyForms(previous => {
      if (previous.has(id) === dirty) return previous;
      const next = new Set(previous);
      if (dirty) next.add(id);
      else next.delete(id);
      return next;
    });
  }, []);

  return <UnsavedChangesContext.Provider value={{
    hasUnsavedChanges: dirtyForms.size > 0,
    registerUnsavedChanges,
  }}>
    {children}
  </UnsavedChangesContext.Provider>;
};

export const useUnsavedChanges = () => useContext(UnsavedChangesContext);
